import React from 'react';

import * as classes from './style.module.scss';

export const TopAnchor: React.FC = () => {
  return (
    <div className={classes.root}>
      <div aria-hidden="true" id="content-top" className={classes.anchor} />
    </div>
  );
};
